function TvPlanSteps(props) {
    return (
    	<div className="tv-plan-steps">
    		{props.children}
    	</div>
    );
}

export default TvPlanSteps;